import React from 'react';
import Image from 'next/image'
import Link from 'next/link'
import StartaProject from '@/components/StartaProject'
import Head from 'next/head'
import MoreBtn from '@/components/comman/MoreBtn'
import { GetStaticPaths, GetStaticProps } from 'next';
import { getSingleServicesData } from '../../lib/services';
import { getIndustriesListingData } from '../../lib/industries';
import ScrollToElement from '@/components/comman/SectionScroll'
import BrandSlider from '@/components/comman/BrandSlider';
import { getSeoDataServices  } from '../../lib/seo';
import SEO from '@/components/SEO'
import IndustriesForm from '@/components/IndustriesForm';

function SingleService({initialService, initialServices,initialIndustriesListing, initialSeo }:any) {

    // const [service, setService] = useState(initialService );
    // const [services, setServices] = useState(initialServices );
    
    // related service display start:
    const relatedServices = initialServices.filter((s: any) => s.node.slug !== initialService.node.slug).slice(0, 4);
    // related service display end:


    const banner = initialService?.node?.services?.bannerServices
    const enquiries = initialService?.node?.services?.enquiriesService
    const successful  = initialService?.node?.services?.successfulService
    const handCraftedService  = initialService?.node?.services?.handCraftedService
    const featuredProject  = initialService?.node?.services?.featuredProject
    const testimonial  = initialService?.node?.services?.testimonial

  return (
    <div className='single_service_page'>
       <SEO initialSeo={initialSeo}/>
       {
        banner?.bannerImage?.sourceUrl && banner?.bannerTitle && (
            <section className='full_banner'>
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-lg-5">
                            <div className="left_banner">
                                <div className="caption">
                                    {
                                        banner?.bannerSubTitle && (
                                            <span className='sub_heading' data-aos="fade-right" data-aos-delay="100">{banner?.bannerSubTitle}</span>
                                        )
                                    }
                                    {
                                        banner?.bannerTitle && (
                                            <h1 data-aos="fade" data-aos-delay="100">{banner?.bannerTitle}</h1>
                                        )
                                    }
                                      {
                                        banner?.bannerDescription &&(
                                            <p data-aos="fade" data-aos-delay="200">
                                                {banner?.bannerDescription}
                                            </p>
                                        )
                                      }
                                      {
                                        banner?.bannerButton?.url && (
                                            <Link href={banner?.bannerButton?.url} className="cmn_btn" data-aos="fade-up" data-aos-delay="100">
                                                <span>{banner?.bannerButton?.title}</span>
                                            </Link>
                                        )
                                      }
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-7">
                            <div className="right_banner">
                                <div className="right_img" data-aos="fade-left" data-aos-delay="100">
                                    <Image src={banner?.bannerImage?.sourceUrl} alt={banner?.bannerTitle} width={1105} height={944} loading="eager"/>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <MoreBtn sectionId='bookacall'/>
            </section>
        )
       }
       {
        enquiries?.enquiriesBoxes && enquiries?.enquirieTitle &&(
        <section id='bookacall' className='section'>
            <div className="container">
                <div className="row">
                    <div className="col-lg-4">
                        <div className="section_title">
                            <h2 data-aos="fade" data-aos-delay="100">{enquiries?.enquirieTitle}</h2>
                        </div>
                        {
                            enquiries.enquirieDescription && (
                                <p data-aos="fade" data-aos-delay="200">
                                    {enquiries?.enquirieDescription}
                                </p>
                            )
                        }
                        {
                            enquiries?.enquirieButton?.url && (
                                <Link href={`${enquiries?.enquirieButton?.url}`} className='cmn_btn_fill' data-aos="fade-down" data-aos-delay="100">
                                    <span>{enquiries?.enquirieButton?.title}</span>
                                </Link>
                            )
                        }
                                            </div>
                    <div className="col-lg-7 col-lg-7 offset-lg-1 col-md-12">
                        <div className="row gx-5">
                            {enquiries?.enquiriesBoxes && enquiries?.enquiriesBoxes.map((enquirieBox:any,index:any)=>{
                                return(
                                    <div key={index} className="col-lg-4">
                                        <div className="www_box" data-aos="fade" data-aos-delay="100">
                                            <div className="sb_icon" data-aos="fade-down" data-aos-delay="100">
                                                <Image src={enquirieBox?.enquiriesIcon?.sourceUrl} alt={enquirieBox?.enquiriesIcon?.altText} width={41} height={40} loading="lazy"/>
                                            </div>
                                            <h3 className='f24 fw-800'>{enquirieBox?.enquiriesTitle}</h3>
                                            <div className="enqury_content_box" dangerouslySetInnerHTML={{ __html: enquirieBox?.enquirieDescription || '' }}></div>
                                            {/* <p>
                                                {enquirieBox?.enquirieDescription}
                                            </p> */}
                                        </div>
                                    </div>
                                )
                            })}
                        </div>
                    </div>
                </div>
            </div>
        </section>
        )
       }
        {
            successful?.successfulBoxes &&  successful?.title &&(
            <section className='section position-relative theme_black'>
                <ScrollToElement targetId="testimonial" buttonClassName="section_scroll"/>
                <div className="container">
                    <div className="row">
                        <div className="col-lg-4 white">
                            <h2 data-aos="fade" data-aos-delay="100">{successful?.title}</h2>    
                        </div>
                        {
                            successful?.description && (
                                <div className="col-lg-7 col-lg-7 offset-lg-1 col-md-12">
                                    <div className="sb_right white">
                                        <p data-aos="fade" data-aos-delay="200">
                                            {successful?.description}
                                        </p>
                                    </div>
                                </div>
                            )
                        }
                    </div>
                    <div className="sb_list white">
                        <div className="row gx-5">
                            {successful?.successfulBoxes && successful?.successfulBoxes.map((successfulBoxe:any,index:any)=>{
                                return(
                                    <div key={index} className="col-lg-4">
                                        <div className="www_box" data-aos="fade" data-aos-delay="100">
                                            <div className="sb_icon" data-aos="fade-down" data-aos-delay="100">
                                                <Image src={successfulBoxe?.icon?.sourceUrl} alt={successfulBoxe?.successfulTitle} width={41} height={33}  loading="lazy"/>
                                            </div>
                                            <h3 className='f24 fw-800'>{successfulBoxe?.successfulTitle}</h3>
                                            <p>
                                                {successfulBoxe?.successfulDescription}
                                            </p>
                                        </div>
                                    </div>
                                )
                            })}
                        </div>
                    </div>
                </div>
            </section>
            )
        }
        <section id='testimonial' className='section  border_top testimonial theme_black'>
            <div className="container">
                <BrandSlider/>
            </div>
        </section>
        {
            testimonial?.selectTestimonial?.content && testimonial?.selectTestimonial?.title && (
                <section className='img_testimonial'>
                    <div className="container">
                        <div className="iTstimonial">
                            <div className="iTestiBox">
                                <div className="iTesti_img" >
                                    {
                                        testimonial?.selectTestimonial?.featuredImage?.node?.sourceUrl && (
                                            <Image src={testimonial?.selectTestimonial?.featuredImage?.node?.sourceUrl ||  '/images/placeholder.jpg'} alt={testimonial?.selectTestimonial?.featuredImage?.node?.altText} width={458} height={439} data-aos="fade-right" data-aos-delay="100" loading="lazy"/>
                                        )
                                    }
                                </div>
                                <div className="iTestContent">
                                    <div className="it_description" dangerouslySetInnerHTML={{ __html: testimonial?.selectTestimonial?.content || '' }}></div>
                                    <div className="iTestInfo">
                                        
                                        <div className="brand_logo" data-aos="fade-down" data-aos-delay="100">
                                        {
                                            testimonial?.selectTestimonial?.testimonial?.companyLogo?.sourceUrl && (
                                                <Image src={testimonial?.selectTestimonial?.testimonial?.companyLogo?.sourceUrl ||  '/images/placeholder.jpg'} alt={testimonial?.selectTestimonial?.testimonial?.companyLogo.altText} width={228} height={50} loading="lazy"/>
                                            )
                                        }
                                        </div>
                                        <div className="client_details">
                                            <h3 data-aos="fade" data-aos-delay="100" >{testimonial?.selectTestimonial?.title}</h3>
                                            {
                                                testimonial?.selectTestimonial?.testimonial?.designation && (
                                                    <span data-aos="fade" data-aos-delay="200">{testimonial?.selectTestimonial?.testimonial?.designation}</span>
                                                )
                                            }
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            )
        }
        {
            handCraftedService?.handCraftedAccordians &&  handCraftedService?.handCraftedServiceImage?.sourceUrl && (
                <section className='section zigzag1'>
                    <div className="container-fluid">
                        <div className="row">
                            <div className="col-xl-4 col-lg-5">
                                <div className="z1_left">
                                    {
                                        handCraftedService?.title &&(
                                            <div className="section_title">
                                                <h2 data-aos="fade" data-aos-delay="100">{handCraftedService?.title}</h2>
                                            </div>
                                        )
                                    }
                                    <div className="accordion" id="accordionExample" data-aos="fade-right" data-aos-delay="100">
                                    {handCraftedService.handCraftedAccordians &&
                                        handCraftedService.handCraftedAccordians.map((hAcc:any, index:any) => (
                                            <div className="accordion-item" key={index}>
                                                <h2 className="accordion-header">
                                                    <button className={`accordion-button ${index === 0 ? '' : 'collapsed'}`} type="button" data-bs-toggle="collapse" data-bs-target={`#faq${index + 1}`} aria-expanded={index === 0 ? 'true' : 'false'} aria-controls={`faq${index + 1}`}>

                                                        <span className="a_number">{index < 9 ? `0${index + 1}` : `${index + 1}`}</span>{hAcc?.title}

                                                    </button>
                                                </h2>
                                                <div id={`faq${index + 1}`} className={`accordion-collapse collapse ${ index === 0 ? 'show' : ''}`}data-bs-parent="#accordionExample">
                                                    <div className="accordion-body">
                                                        <p>{hAcc?.description}</p>
                                                    </div>
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            </div>
                            <div className="col-xl-8 col-lg-7">
                                <div className="z1_right">
                                    <div className="z1_img" data-aos="fade-left" data-aos-delay="100">
                                        <Image src={handCraftedService?.handCraftedServiceImage?.sourceUrl} alt={handCraftedService?.handCraftedServiceImage?.altText} width={1398} height={1007} loading="lazy"/>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            )
        }
        {
            relatedServices && (
                <section className='sp_bottom'>
                    <div className="container">
                        <div className="section_title bottom center">
                            <h2 data-aos="fade" data-aos-delay="100">Related Services</h2>
                        </div>

                        <div className="sb_list">
                            <div className="row gx-5">
                                {
                                    relatedServices && relatedServices.map((rservice:any,index:any)=>{
                                        return(
                                            <div key={index} className="col-lg-3">
                                                <div className="www_box" data-aos="fade" data-aos-delay="100">
                                                    <div className="sb_icon" data-aos="fade-down" data-aos-delay="100">
                                                        <Image src={rservice?.node?.services?.bannerServices?.relativeIcon?.sourceUrl || '/images/web-development.svg'} alt={rservice.node.title} width={40} height={41} loading="lazy"/>
                                                    </div>
                                                    <Link href={`/services/${rservice.node.slug}`}>
                                                        <h3 className='f24 fw-800'>{rservice.node.title}</h3>
                                                    </Link>

                                                    {rservice.node.excerpt ? (
                                                    <div dangerouslySetInnerHTML={{ __html: rservice?.node?.excerpt || '' }}></div>
                                                    ) : (
                                                        <p>{rservice?.node?.services?.bannerServices?.bannerDescription}</p>
                                                    )}
                                                </div>
                                            </div>
                                        )
                                    })
                                }
                            </div>
                        </div>
                    </div>
                </section>
            )
        }
        {
            featuredProject?.selectFeaturedProject?.projects?.projectsBackgroundImage?.sourceUrl && featuredProject?.selectFeaturedProject?.title && (
            <section>
                <div className="zig50 without_screen">
                    <div className="zig50_left" style={{backgroundImage: `url('${featuredProject?.selectFeaturedProject?.projects.projectsBackgroundImage?.sourceUrl}')`}}>
                        {/* <div className="zig50_center">
                            <div className="laptop" data-aos="fade-right" data-aos-delay="100">
                                <Image src="/images/macbook.png" alt="macbook  apple" width={1263} height={831} loading="lazy"/>
                                <div id="macScreen" style={{backgroundImage: `url('${featuredProject?.selectFeaturedProject?.projects.projectImage?.sourceUrl}')`}}></div>
                            </div>
                        </div> */}
                         <div className="without_screen_img">
                            <Image src={featuredProject?.selectFeaturedProject?.projects.projectImage?.sourceUrl || '/images/placeholder.jpg'} alt={featuredProject?.selectFeaturedProject?.title || 'placeholder'} width={1067} height={653}/>
                        </div>
                    </div>
                    <div className="zig50_right">
                        <div className="zig50_content">
                        <div className="zig50_wrap">
                                {
                                    featuredProject?.subHeading && (
                                    <span className="sub_heading" data-aos="fade-right" data-aos-delay="100">
                                        {featuredProject?.subHeading}
                                    </span>
                                    )
                                }
                                <h2 data-aos="fade" data-aos-delay="100">{featuredProject?.selectFeaturedProject?.title}</h2>
                                {
                                    featuredProject?.selectFeaturedProject?.content && (
                                        <div className="feature_project_content" dangerouslySetInnerHTML={{ __html: featuredProject?.selectFeaturedProject?.content || '' }}></div> 
                                    )
                                }
                                {
                                    featuredProject?.selectFeaturedProject?.slug && (
                                    <Link href={`/our-works/${featuredProject?.selectFeaturedProject?.slug}`} className='cmn_btn_fill' data-aos="fade-down" data-aos-delay="100">
                                        <span>View project </span>
                                    </Link>
                                    )
                                }
                        </div>
                        </div>
                    </div>
                </div>
            </section>
            )
        }
        <section className='section'>
            <div className="container">
                <div className="ind_form">
                    <IndustriesForm  initialIndustriesListing={initialIndustriesListing}/>
                </div>
            </div>
        </section>
        <StartaProject/>
    </div>
  )
}

export default SingleService

export const getStaticPaths: GetStaticPaths = async () => {
    const services = await getSingleServicesData();
    const paths: { params: { slug: string[] } }[] = [];

    services.forEach((service: any) => {
        // Add parent service paths
        paths.push({ params: { slug: [service.node.slug] } });

        // Add paths for child services
        if (service.node.children && service.node.children.nodes.length > 0) {
            service.node.children.nodes.forEach((child: any) => {
                paths.push({ params: { slug: [service.node.slug, child.slug] } });
            });
        }
    });

    return { paths, fallback: false }; // All paths must be pre-rendered
};

export const getStaticProps: GetStaticProps = async ({ params }: any) => {
    const parentSlug = params.slug[0]; // Parent service slug
    const childSlug = params.slug[1] || ""; // Child service slug (if exists)

    // Fetch all services data
    const initialServices = await getSingleServicesData();

    // Find the parent service by slug
    const parentService = initialServices.find((s: any) => s.node.slug === parentSlug);

    // If the parent service doesn't exist, return 404
    if (!parentService) {
        console.error(`No parent service found for slug: ${parentSlug}`);
        return { notFound: true }; 
    }

    // Check if the current slug is a child of any parent service
    const isDirectChildSlug = initialServices.some((service:any) => 
        service.node.children.nodes.some((child:any) => child.slug === params.slug[0])
    );

    if (isDirectChildSlug && !childSlug) {
        // If the accessed slug is a child slug but no specific child is provided, return 404
        console.error(`Slug '${params.slug[0]}' is a child of a parent service, returning 404.`);
        return { notFound: true };
    }

    // Handle fetching for the child service if childSlug is provided
    if (childSlug) {
        const childService = initialServices.find((s:any) => s.node.slug === childSlug);
        if (childService) {
            // If a valid child service is found, return its data
            return { props: { initialService: childService, initialServices, initialSeo: await getSeoDataServices(childSlug) } };
        } else {
            console.error(`Child slug '${childSlug}' not found, returning 404.`);
            return { notFound: true };
        }
    }

    // If there's no childSlug, return the parent service data
    return { props: { initialService: parentService, initialServices, initialSeo: await getSeoDataServices(parentSlug) } };
};
